import { ref, onMounted } from 'vue';
import { provideLocal, injectLocal } from '@vueuse/core';
import { post } from '@utils/api';
import { useEnvProps } from '@composables/useEnvProps';
import { usePageData } from '@composables/usePageData';
import { getVotes, saveVote } from '@utils/localstorage/votes';

/**
 * @type {import('vue').InjectionKey<import('vue').Ref<Object<string,*>>>}
 */
const VOTES_KEY_REPOSITORY = Symbol('VOTES_KEY_REPOSITORY');

export const useVoteProvide = () => {
  /**
   * @type {import('vue').Ref<Object<string,*>>}
   */
  const votes = ref({});
  provideLocal(VOTES_KEY_REPOSITORY, votes);
};

const useVote = () => {
  const votes = injectLocal(VOTES_KEY_REPOSITORY);

  if (!votes) {
    throw new Error('useVote must be used within a useVoteProvide');
  }

  const loadVotes = () => {
    votes.value = getVotes();
  };

  onMounted(loadVotes);

  const { productId } = usePageData();
  const { hostlink } = useEnvProps();
  /**
 * submits vote to XAPI
 *
 * @param {number} id
 * @param {Function} onError
 * @param {Boolean=} isComment
 */
  async function submitVoteFeedback(id, onError, isComment = false) {
    try {
      const vote = votes?.value[id];
      if (!vote) {
        const resp = await post(
          `${hostlink}/xapi/digital/v1/product/${productId}/reviews/${id}/feedback${isComment ? '?reviewComment=true' : ''}`,
          {
            SubmitFeedbackRequest: {
              feedbackType: 'helpfulness',
              userId: id,
              feedbackValue: 'positive',
            },
          },
          {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          },
        );

        if (resp.review?.success) {
          saveVote(id);
          loadVotes();
        } else {
        // show error popup
          onError();
        }
      }
    } catch (e) {
      /* eslint-disable no-console */
      console.error('Server error', e);
      // show same error popup
      onError();
    }
  }

  return {
    votes,
    loadVotes,
    submitVoteFeedback,
    /**
     *
     * @param {number} id
     * @param {Function} onError
     * @returns
     */
    submitCommentVoteFeedback: (id, onError) => submitVoteFeedback(id, onError, true),
  };
};

export default useVote;
